import { Dispatch, Reducer } from "redux";
import { DropdownItemProps } from "semantic-ui-react";
import {
    GET_JUSTIFICATIONS,
    ADD_JUSTIFICATION,
    REMOVE_JUSTIFICATION,
} from "../actions/justificationsActions";
import { getJustifications } from "../services/justificationsService";

export interface JustificationsState extends DropdownItemProps {}

const initialState: JustificationsState[] = [];

export const justificationsReducer: Reducer<JustificationsState[]> = (
    state: JustificationsState[] = initialState,
    action: any
): JustificationsState[] => {
    switch (action.type) {
        case GET_JUSTIFICATIONS:
            return action.payload;
        case ADD_JUSTIFICATION:
            return state.concat(action.justProp);
        case REMOVE_JUSTIFICATION:
            return state.filter(x => x.key !== action.justProp.key);
        default:
            return state;
    }
};

export async function fetchJustifications(dispatch: Dispatch) {
    const res = await getJustifications();
    dispatch({ type: GET_JUSTIFICATIONS, payload: res });
}
